import React from 'react';
import Progress from '../components/circular-progress-bar/Progress';
// const Progress = React.lazy(() => import('../components/circular-progress-bar/Progress'))

const skills = [
    {
        name: 'React.js',
        percentage: '78'
    },
    {
        name: 'Node.js',
        percentage: '60'
    },
    {
        name: 'C++',
        percentage: '75'
    },
    {
        name: 'DSA',
        percentage: '65'
    },
]

const otherSkills = [
    {
        name: 'Python'
    },
    {
        name: 'MongoDB'
    },
    {
        name: 'Git'
    },
    {
        name: 'React Native'
    },
]

const Skills = () => {
    return (
        <div className='bg-gray-800' id='skills' style={{ minHeight: '100vh' }}>
            <div>
                <div className="text-center text-white subheadings-font text-4xl font-bold pt-24">
                    Skills
                </div>
                <div className="w-full mt-10">
                    <Progress skills={skills} />
                </div>
            </div>
            <div className='pb-5 mt-5 md:mt-20'>
                <div className="text-center text-white subheadings-font text-2xl font-bold">
                    Other Skills
                </div>
                <div className='flex justify-around align-center flex-wrap bg-gray-800'>
                    {otherSkills.map((skill, index) => {
                        return (
                            <div key={index} className="w-44 px-4 py-2 mx-2 my-3 md:my-1 md:mt-3 bg-white font-nexaBold rounded text-center">
                                {skill.name}
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default Skills
